import { ResourceType } from '../../../../core/shared/resource-type';

/**
 * The resource type for FacetConfigResponse
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const FACET_CONFIG_RESPONSE = new ResourceType('discovery-facets');
